import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { pushCompanyRoute } from "modules/app/actions";
import { Button, Menu } from "lib/components/index";
import {
  Link,
  SubBar,
  MainView,
  SidebarView,
  ProductsList,
  FormControl,
  PaginationNavigation,
  Message,
} from "lib/components/index";
import openNewProductPrompt from "modules/products/NewProductPrompt/NewProductPrompt";
import ProductsListFilters from "./ProductsListFilters";
import {
  stateSelector,
  initializeView,
  destroyView,
  fetchProducts,
  changePagination,
  changeFilters,
  changeFiltersAndResetOffset,
} from "./index";
import { st } from "lib/index";

// const filterScopeOptions = [
//   ["all", I18n.t("papp.calendar.CalendarView.filter_all")],
//   ["available", I18n.t("papp.calendar.CalendarView.filter_available")],
//   ["not-available", "Niedostepne"]
// ];

const filterScopeOptions = [];

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    sidebarVisible: state.app.sidebarVisible,
    filters: stateSelector(state).filters,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
    products:
      stateSelector(state).products &&
      stateSelector(state).products &&
      stateSelector(state).products.model &&
      stateSelector(state).products.model.records,
    totalCount:
      stateSelector(state).products &&
      stateSelector(state).products.model &&
      stateSelector(state).products.model.meta.total_count,
    aggregations:
      stateSelector(state).products &&
      stateSelector(state).products.model &&
      stateSelector(state).products.model.aggregations,
    fetchDone: stateSelector(state).products.fetchDone,
    fetchLoading: stateSelector(state).products.fetchLoading,
    fetchFailed: stateSelector(state).products.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        fetchProducts,
        changePagination,
        changeFilters,
        changeFiltersAndResetOffset,
        pushCompanyRoute,
      },
      dispatch
    )
)
export default class ProductsListView extends React.PureComponent {
  state = {
    query: "",
  };

  componentDidMount() {
    this.props.initializeView();

    const { query } = this.props.location;
    if (query && Object.keys(query).length > 0) {
      this.props.changeFilters(query);
    }
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  handleProductCreateClick() {
    const { currentCompany, pushCompanyRoute, fetchProducts } = this.props;
    openNewProductPrompt({ company: currentCompany }).then((product) => {
      // refetch products so ProductsRepository.getAll() will include the new product
      fetchProducts();
      pushCompanyRoute(`/products/${product.id}/edit`);
    });
  }

  onChangeProductsFilter = (query, filters) => {
    this.setState({
      query: query.search,
    });

    if (query.search.length < 3 && query.search.length > 0) return null;

    this.props.changeFilters({ ...filters, ...query });
    this.props.changePagination({ offset: 0, limit: 10 });
  };

  render() {
    const {
      currentCompany,
      currentProducts,
      fetchDone,
      fetchLoading,
      fetchFailed,
      fetchProducts,
      aggregations,
      filters,
      offset,
      limit,
      totalCount,
      changeFilters,
      changeFiltersAndResetOffset,
      changePagination,
      sidebarVisible,
    } = this.props;

    const { query } = this.state;
    const products = this.props.products;

    return (
      <SidebarView.Container>
        <SidebarView.Sidebar label={I18n.t("papp.common.filters_title")} extended={sidebarVisible}>
          <ProductsListFilters
            currentCompany={currentCompany}
            currentProducts={currentProducts}
            aggregations={aggregations}
            filters={filters}
            onFiltersChange={(filters) => changeFiltersAndResetOffset(filters)}
          />
        </SidebarView.Sidebar>
        <SidebarView.Content hasSidebar={sidebarVisible}>
          <MainView.Container>
            <SubBar hasSidebar={sidebarVisible}>
              <div className="pull-left u-inlineFlexRow">
                <h1>{I18n.t("papp.products.ProductsListView.products")}</h1>
                <FormControl.Input
                  value={query}
                  onChange={(query) => this.onChangeProductsFilter({ search: query }, filters)}
                  placeholder={I18n.t("papp.products.ProductsListView.search_top_bar")}
                  className="u-marginLeft c-inputStandard products-wider-input"
                />
              </div>
              <div className="pull-right">
                {fetchDone && totalCount > 0 && (
                  <PaginationNavigation
                    offset={offset}
                    limit={limit}
                    totalCount={totalCount}
                    onChange={changePagination}
                    name="productsLimit"
                  />
                )}
                {/* button hidden for all roles */}
                {!["global_admin", "main_admin", "editor_admin", "company_admin", "company_employee"].includes(
                  st.authorize.member.role
                ) && (
                  <Button
                    as={Link}
                    className="u-marginRight"
                    to={`/c/${currentCompany.id}/settings/company/products`}
                    content={I18n.t("papp.products.ProductsListView.settings")}
                  />
                )}
                {currentCompany.supplier && (
                  <Button
                    as="a"
                    primary
                    onClick={this.handleProductCreateClick.bind(this)}
                    content={I18n.t("papp.products.ProductsListView.add_new_product")}
                  />
                )}
              </div>
              <div className="pull-right">
                <Menu secondary pointing className="offer_filters u-marginRight u-marginTop">
                  {filterScopeOptions.map(([scope, label]) => (
                    <Menu.Item
                      key={scope}
                      // active={filters.scope === scope}
                      // onClick={bind(this.handleFilterChange, this, "scope", scope)}
                      content={label}
                    />
                  ))}
                </Menu>
              </div>
            </SubBar>
            <MainView.Content grayBackground hasSubBar>
              <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchProducts} />
              {fetchDone && products.length === 0 && (
                <MainView.DimmerContent
                  icon="sentiment_neutral"
                  title={I18n.t("papp.products.ProductsListView.no_products_title")}
                >
                  <p>
                    {I18n.t("papp.products.ProductsListView.no_products_message")}{" "}
                    <a className="u-cursorPointer" onClick={this.handleProductCreateClick.bind(this)}>
                      {I18n.t("papp.products.ProductsListView.no_products_message_link")}
                    </a>
                  </p>
                </MainView.DimmerContent>
              )}
              {fetchDone && products.length === 0 && <Message>{I18n.t("papp.common.no_results_message")}</Message>}
              {fetchDone && products.length > 0 && (
                <ProductsList products={products} groupedByCompany={currentCompany.agent} />
              )}
            </MainView.Content>
          </MainView.Container>
        </SidebarView.Content>
      </SidebarView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/ProductsListView/ProductsListView.jsx